import { Box, BoxProps, Stack, Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";

export const pageTabHeaderTypographyProps = {
  title: { variant: "h3" } as TypographyProps,
  subtitle: { variant: "subtitle1", color: "text.secondary" } as TypographyProps,
  subtitle2: { variant: "caption", color: "text.secondary" } as TypographyProps,
};

export interface PageTabHeaderProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  subtitle2?: ReactNode;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  sx?: BoxProps["sx"];
  /** Same as title. */
  children?: ReactNode;
}

export default function PageTabHeader({
  title,
  subtitle,
  subtitle2,
  primaryAction,
  secondaryAction,
  sx,
  children,
}: PageTabHeaderProps) {
  return (
    <Stack
      data-testid='page-tab-header'
      direction='row'
      spacing={1}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        ...sx,
      }}
    >
      <Box>
        <Typography {...pageTabHeaderTypographyProps.title}>{title || children}</Typography>

        {subtitle && (
          <Typography component='div' {...pageTabHeaderTypographyProps.subtitle}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <Stack gap={1}>
        {(secondaryAction || primaryAction) && (
          <Stack sx={{ overflow: "hidden" }} direction={{ xxs: "column", md: "row" }} gap={1}>
            {primaryAction && <Box>{primaryAction}</Box>}

            {secondaryAction && <Box>{secondaryAction}</Box>}
          </Stack>
        )}

        {subtitle2 && (
          <Typography
            component='div'
            {...pageTabHeaderTypographyProps.subtitle2}
            sx={{ minWidth: 0 }}
          >
            {subtitle2}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
